import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=5435d8ba&scoped=true&"
import script from "./Textarea.vue?vue&type=script&lang=js&"
export * from "./Textarea.vue?vue&type=script&lang=js&"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=5435d8ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5435d8ba",
  null
  
)

export default component.exports